import { adminAxiosInstance } from "@pulse/api/axiosInstance";

const getAllProductInstances = async (): Promise<ProductInstance[]> => {
    const response = (await adminAxiosInstance.get(`admin/product-instances`)).data;
    return response.data;
};

export type ProductInstance = {
    name: string;
    id: number;
    productId: number;
    compublishId: number;
    url: string;
    newTemplate: boolean;
    slug: string;
    deletedAt: string | null;
    disabledAt: string | null;
    product?: Product;
    customerId: number;
    updatedById: number;
};

export type Product = {
    id: number;
    name: string;
    createdAt: string;
    type: string;
    compublishId: number;
    blockProduct: boolean;
};

export { getAllProductInstances };
